<template>
  <article
    :id="`rate-${rate.id}`"
    class="lpu-review-card d-flex"
    :class="[
      cardClasses,
      isMobile
        ? 'flex-column ga-3 py-6'
        : 'align-start pa-8',
    ]"
    data-qa="review_card"
    :data-review-id="rate.id"
    :data-review-type="rate.rate_type || (rate.doctor ? 'doctor' : 'lpu')"
    :data-review-is-deleted="rate.is_deleted ? 'true' : 'false'"
    :data-year="year"
    itemprop="review"
    itemscope
    itemtype="https://schema.org/Review"
  >
    <ReviewCardMeta
      :rate="rate"
      :lpu="lpu"
      @open-author="$emit('open-author', $event)"
    />
    <section
      class="lpu-review-card__body"
      itemprop="reviewBody"
      :data="`1${rate.id}`"
      :data-rtype="rate.ratetype"
    >
      <ReviewCardBody
        :rate="rate"
        :lpu="lpu"
        @open-image="$emit('open-image', $event)"
      />
    </section>
  </article>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import ReviewCardBody from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardBody.vue'
import ReviewCardMeta from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardMeta.vue'
import getReviewCardClass from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/getReviewCardClass'
import { getReviewYear } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/formatReviewDates'

const props = defineProps<{
  rate: Rate
  lpu: Lpu
}>()

const isMobile = useIsMobile()

defineEmits(['open-image', 'open-author'])

const year = computed(() => getReviewYear(props.rate.dt_created))
const cardClasses = computed(() => [
  getReviewCardClass(props.rate),
  year.value ? `year${year.value}` : '',
])
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.lpu-review-card {
  column-gap: 93px;
  border-top: 1px solid $ui-kit-bg-gray-60;

  &__body {
    flex: 1 1 0;
    min-width: 0;
  }
}
</style>
